import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "p-4" }
const _hoisted_2 = { class: "flex items-start" }
const _hoisted_3 = { class: "flex-shrink-0" }
const _hoisted_4 = { class: "ml-3 w-0 flex-1 pt-0.5" }
const _hoisted_5 = {
  key: 0,
  class: "text-sm font-medium text-gray-900 mb-1"
}
const _hoisted_6 = { class: "text-sm text-gray-500 max-h-20 overflow-hidden" }
const _hoisted_7 = { class: "ml-4 flex flex-shrink-0" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ExclamationCircleIcon = _resolveComponent("ExclamationCircleIcon")!
  const _component_CheckCircleIcon = _resolveComponent("CheckCircleIcon")!
  const _component_XIcon = _resolveComponent("XIcon")!

  return (_ctx.isVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1", { 'ring-green-500': _ctx.type !== 'error', 'ring-red-500': _ctx.type == 'error' }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              (_ctx.type == 'error')
                ? (_openBlock(), _createBlock(_component_ExclamationCircleIcon, {
                    key: 0,
                    class: "h-6 w-6 text-red-600"
                  }))
                : (_openBlock(), _createBlock(_component_CheckCircleIcon, {
                    key: 1,
                    class: "h-6 w-6 text-green-400"
                  }))
            ]),
            _createElementVNode("div", _hoisted_4, [
              (_ctx.type !== 'error')
                ? (_openBlock(), _createElementBlock("p", _hoisted_5, "Successfully saved!"))
                : _createCommentVNode("", true),
              _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.text || ''), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("button", {
                type: "button",
                class: "inline-flex rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isVisible = false))
              }, [
                _hoisted_8,
                _createVNode(_component_XIcon, { class: "w-5 h-5" })
              ])
            ])
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}